"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Anushavan.Hovsepyan on 12/23/2016.
 */
var core_1 = require("@angular/core");
var sis_tab_component_1 = require("./sis-tab.component");
var subscription_manager_decorator_1 = require("../shared/subscription-manager.decorator");
/**
 * @deprecated use Material tabs instead.
 * Represents the tab panel control for large number of tabs for content navigation
 * and there are visible only three tabs.
 * @class
 */
require("./sis-nav-tabs.component.css");
var NavTabsComponent = /** @class */ (function () {
    function NavTabsComponent() {
        /**
         * Shows navigation buttons disabled or not
         * @public
         * @member {boolean}
         * @type {boolean}
         */
        this.disableNavigation = true;
        /**
         * Used to emit the _selectedTabId change event
         * @public
         * @member {EventEmitter}
         * @type {EventEmitter}
         */
        this._selectedTabChange = new core_1.EventEmitter();
    }
    Object.defineProperty(NavTabsComponent.prototype, "selectedTabIndex", {
        get: function () {
            return this._selectedTabIndex;
        },
        set: function (value) {
            this._selectedTabIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Checks the `_selectedTabId` changes and calls for `changeSelectedTab` to handle the change
     * @param {SimpleChange} changes
     * @returns {void}
     * @public
     * @method
     */
    NavTabsComponent.prototype.ngOnChanges = function (changes) {
        // check the `_selectedTabId` and select corresponding tab
        if (changes['_selectedTabId']) {
            this._selectedTabId = changes['_selectedTabId'].currentValue;
            this.changeSelectedTab(this._selectedTabId);
        }
    };
    /**
     * Subscribes for `tabItems` and triggers it once
     * @returns {void}
     * @private
     * @method
     */
    NavTabsComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.$sm = this._childrens.changes.subscribe(function () {
            _this.tabItemsChanged();
        });
        this.tabItemsChanged();
    };
    /**
     * Validates the `tabItems`, if it has no selected tab, then selects the first
     * @returns {void}
     * @private
     * @method
     */
    NavTabsComponent.prototype.tabItemsChanged = function () {
        this.validateTabItems();
        this._tabs = this._childrens.toArray();
        if (this._selectedTabId === undefined || this._selectedTabId === null) {
            this._selectedTabId = +this._tabs[0].getId();
        }
        var selectedTab = this.getTabById(this._selectedTabId);
        this._selectedTabIndex = this._tabs.indexOf(selectedTab);
        this.selectTab(this._selectedTabIndex);
    };
    /**
     * Must be called each time the `_selectedTabId` is changed, it will try to find and select a tab with new id
     * @param {number} selectedTabId
     * @returns {void}
     * @public
     * @method
     */
    NavTabsComponent.prototype.changeSelectedTab = function (selectedTabId) {
        var tab = this.getTabById(selectedTabId);
        if (tab !== undefined && tab !== null) {
            this._selectedTabIndex = this._tabs.indexOf(tab);
            this.selectTab(this._selectedTabIndex);
        }
    };
    /**
     * Marks the given `tabItem` as `selected` and emits the `onTabSelected` event
     *         if the `tabItem` is not already selected
     *         otherwise does nothing
     * @param {number} selectedTabIndex
     * @returns {void}
     * @private
     * @method
     */
    NavTabsComponent.prototype.selectTab = function (selectedTabIndex) {
        var selectedTab = this._tabs[selectedTabIndex];
        if (!selectedTab.selected && selectedTab.isEnabled) {
            // deselect the currently selected tab
            this.deselectTabs();
            // Hack to overcome an issue with 'checked binding' in Angular.
            setTimeout(function () {
                // select given tab
                selectedTab.selected = true;
            }, 1);
            this._selectedTabId = +selectedTab.getId();
            this._selectedTabIndex = this._tabs.indexOf(selectedTab);
            // emit the change event
            this._selectedTabChange.emit(selectedTab.getId());
        }
    };
    /**
     * Deselects tabs.
     */
    NavTabsComponent.prototype.deselectTabs = function () {
        this._tabs.forEach(function (tabItem) {
            tabItem.selected = false;
        });
    };
    /**
     * Validates tabItems, checks for duplicate ids
     * @throw {Error} `tabItems` must be initiated and have unique ids or undefined ids
     * @returns {void}
     * @private
     * @method
     */
    NavTabsComponent.prototype.validateTabItems = function () {
        if (this._childrens === undefined || this._childrens === null) {
            throw new Error("Invalid tabItems");
        }
        var tabIds = [];
        this._childrens.forEach(function (tabItem) {
            var id = tabItem.getId();
            if (-1 < tabIds.indexOf(id)) {
                throw new Error("More than one `tabItem` in `tabItems` has the same `id`: " + tabItem.getId());
            }
            if (id !== undefined && id !== null) {
                tabIds.push(tabItem.getId());
            }
        });
    };
    /**
     * Searches for a tab in `tabItems` with given `tabId`
     * @param {number} tabId
     * @returns {TabComponent | undefined}
     * @private
     * @method
     */
    NavTabsComponent.prototype.getTabById = function (tabId) {
        var tab = null;
        if (this._tabs !== undefined && this._tabs !== null) {
            for (var _i = 0, _a = this._tabs; _i < _a.length; _i++) {
                var tempTab = _a[_i];
                if (+tempTab.getId() === tabId) {
                    tab = tempTab;
                    break;
                }
            }
        }
        return tab;
    };
    /**
     * Checkes selected tab has previous tab or not
     * @returns {TabComponent | undefined}
     * @private
     * @method
     */
    NavTabsComponent.prototype.hasPrevious = function () {
        return this._selectedTabIndex > 0;
    };
    /**
     * Checkes selected tab has next tab or not
     * @returns {TabComponent | undefined}
     * @private
     * @method
     */
    NavTabsComponent.prototype.hasNext = function () {
        return this._selectedTabIndex + 1 < this._tabs.length;
    };
    /**
     * Returns tab title.
     * @param {number} tabIndex
     * @returns {TabComponent | undefined}
     * @private
     * @method
     */
    NavTabsComponent.prototype.getTitle = function (tabIndex) {
        if (tabIndex >= 0 && tabIndex < this._tabs.length) {
            return this._tabs[tabIndex].getTitle();
        }
        else {
            return "";
        }
    };
    __decorate([
        core_1.ContentChildren(sis_tab_component_1.TabComponent),
        __metadata("design:type", core_1.QueryList)
    ], NavTabsComponent.prototype, "_childrens", void 0);
    __decorate([
        core_1.Input("selectedTabId"),
        __metadata("design:type", Number)
    ], NavTabsComponent.prototype, "_selectedTabId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], NavTabsComponent.prototype, "disableNavigation", void 0);
    __decorate([
        core_1.Output("selectedTabChange"),
        __metadata("design:type", Object)
    ], NavTabsComponent.prototype, "_selectedTabChange", void 0);
    NavTabsComponent = __decorate([
        core_1.Component({
            
            selector: "sis-nav-tabs",
            template: require('./sis-nav-tabs.component.html')
        }),
        subscription_manager_decorator_1.SubscriptionManager()
    ], NavTabsComponent);
    return NavTabsComponent;
}());
exports.NavTabsComponent = NavTabsComponent;
//# sourceMappingURL=sis-nav-tabs.component.js.map